import { API, axios, SendRequest} from '@/imports-files/pages/clients/activities/index';


export class FlipPageService extends SendRequest {
  async addRemoveMember(params, job_id, job_stage_id){
    try {
      const result = await axios.put(API.client.kanban.ADD_MEMBER_KANBAN.replace('$job_id', job_id).replace('$job_stage_id', job_stage_id),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}
